import { Field } from 'formik'
import type { FC } from 'react'
import React from 'react'

import type {
  EditableSettingsField,
  SettingsField,
} from '@fourthwall/services/dist/ThemeEditorApiClient'

import { Checkbox } from './fields/Checkbox/Checkbox'
import { Color } from './fields/Color/Color'
import { Header } from './fields/Header/Header'
import { Input } from './fields/Input/Input'
import { Radio } from './fields/Radio/Radio'
import { Range } from './fields/Range/Range'
import { Select } from './fields/Select/Select'
import type { Props } from './types'

function isEditableSetting(setting: SettingsField): setting is EditableSettingsField {
  return 'id' in setting
}

const settingsComponents = (type: string) => {
  const fieldTypes: Record<SettingsField['type'], FC<any> | null> = {
    checkbox: Checkbox,
    color: Color,
    header: Header,
    number: Input,
    radio: Radio,
    range: Range,
    select: Select,
    text: Input,
    // unused
    app_button: null,
    collection: null,
    currency: null,
    date_picker: null,
    font_picker: null,
    html: null,
    image_picker: null,
    memberships_access_type_picker: null,
    memberships_tag_post_picker: null,
    memberships_type_post_picker: null,
    memberships_video_series_picker: null,
    paragraph: null,
    product_selector: null,
    resource: null,
    richtext: null,
    social_link: null,
    url: null,
    video_picker: null,
    video_url: null,
    textarea: null,
    link_list: null,
  }

  return (fieldTypes as any)[type]
}

const InvalidSetting = (props: { setting: SettingsField }) => {
  return <div>Invalid setting: {props.setting.type}</div>
}

export const PreviewSetting = ({
  setting,
  onSettingUpdate,
  onAssetUpload,
  onAssetRemove,
}: Props) => {
  const component = settingsComponents(setting.type)

  if (!component) return <InvalidSetting setting={setting} />

  if (isEditableSetting(setting)) {
    return (
      <div>
        <Field
          name={setting.id}
          component={component}
          data={setting}
          onSettingUpdate={onSettingUpdate}
          onAssetUpload={onAssetUpload}
          onAssetRemove={onAssetRemove}
        />
      </div>
    )
  }

  if (setting.type === 'header') {
    return (
      <div>
        <Header data={setting} />
      </div>
    )
  }

  return <InvalidSetting setting={setting} />
}
